import { useCallback } from 'react';

type PaginationCallback = (page: number) => void;

export const usePagination = () => {
  const nextPage = useCallback(
    (page: number, totalPages: number, callback: PaginationCallback): void => {
      const nextPageValue = Math.min(page + 1, totalPages - 1);
      if (nextPageValue !== page) callback(nextPageValue); 
    },
    []
  );

  const backPage = useCallback(
    (page: number, callback: PaginationCallback): void => {
      const prevPageValue = Math.max(page - 1, 0);
      if (prevPageValue !== page) callback(prevPageValue); 
    },
    []
  );

  return {
    nextPage,
    backPage,
  };
};
